import Icon, * as AntdIcons from '@ant-design/icons';
import * as CustomIcons from '../../assets';
import { isCustomIcon } from './types';
import type { AntdIconNames, CustomIconNames, IconsProps } from './types';
import type { ReactElement, ReactNode } from 'react';

/**
 * 图标组件
 */
export function Icons(props: IconsProps): ReactElement {
  if (typeof props.name !== 'string') {
    return props.name;
  }

  // 使用 svg 图标组件
  if (isCustomIcon(props.name)) {
    const SvgComponent = CustomIcons[props.name as CustomIconNames];
    return <Icon {...props} component={SvgComponent} />;
  }

  // 使用 Antd 图标组件
  const AntdIconComponent = AntdIcons[props.name as AntdIconNames] as React.ComponentType<IconsProps>;
  return <AntdIconComponent {...props} />;
}

export { AntdIcons, CustomIcons };

/**
 * 名称转换为图标组件，
 * 将数据中的图标名称转换为图标组件时使用
 * @param item
 * @returns
 */
export function convert(item?: ReactNode): ReactNode {
  if (item == null) {
    return;
  }

  if (typeof item === 'string') {
    return <Icons name={item as IconsProps['name']} />;
  }

  return item;
}
